import CookieConsent from "./components/cookieConsent/CookieConsent";
import "./app.css";
import { PPConstants } from "@shared/publicportal/constants";
import useSessionStorage, { PpClientSettings } from "@mirage/hooks/useSessionStorage";
import { ClientSettingsService } from "@mirage/services/ClientSettingsService";
import { useState, useEffect } from "react";
import RouteElement from "./routeElement";
import { Backdrop, CircularProgress } from "@mui/material";
import { useInitializeUserSession } from "@mirage/hooks/useInitializeUserSession";
import { PublicPortalRoutingService } from "./services/PublicPortalRoutingService";

const routing = new PublicPortalRoutingService();

export const PublicPortal = () => {
    const [loading, setLoading] = useState(true);
    const appName = PPConstants.AppName;
    const [, setSessionStorage] = useSessionStorage(appName);
    const setInitialUser = useInitializeUserSession(routing.Root);
    const loadingElement = (
        <Backdrop sx={{ color: "#fff" }} open={true}>
            <CircularProgress color="inherit" />
        </Backdrop>
    );

    useEffect(() => {
        setInitialUser(appName);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setLoading(true);
        ClientSettingsService.getInstance(PPConstants.AppName).then((service) => {
            const clientSettings = service.getSettings() as unknown as PpClientSettings;
            service.applySettings();
            setSessionStorage((p) => {
                return {
                    ...p,
                    clientSettings,
                };
            });
            setLoading(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <CookieConsent>{loading ? loadingElement : <RouteElement />}</CookieConsent>;
};
